import React from 'react';
import { createTheme } from '@mui/material/styles';
import type { LinkProps as RouterLinkProps } from 'react-router';
import { Link as RouterLink } from 'react-router';

import { colorSchemes } from './color-schemes';
import { components } from './components/components';
import { shadows } from './shadows';
import type { Direction, PrimaryColor, Theme } from './types';
import { typography } from './typography';

interface Config {
  primaryColor: PrimaryColor;
  direction?: Direction;
}

type LinkBehaviorProps = Omit<RouterLinkProps, 'to'> & {
  href: RouterLinkProps['to'];
};

const LinkBehavior = React.forwardRef<HTMLAnchorElement, LinkBehaviorProps>(
  function LinkBehaviorComponent(props, ref) {
    const { href, ...other } = props;
    return <RouterLink ref={ref} to={href} {...other} />;
  }
);

function customCreateTheme(config: Config): Theme {
  const theme = createTheme({
    breakpoints: { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1440 } },
    colorSchemes: colorSchemes({ primaryColor: config.primaryColor }),
    components: {
      ...components,
      MuiStack: {
        defaultProps: {
          useFlexGap: true,
        },
      },
      MuiLink: {
        defaultProps: {
          component: LinkBehavior,
        },
      },
    },
    cssVariables: {
      colorSchemeSelector: 'class',
    },
    direction: config.direction,
    shadows,
    shape: { borderRadius: 8 },
    typography,
  });

  return theme;
}

export { customCreateTheme as createTheme };
